import { Prescription } from '@/custom/menicon/models';
import { GenericService } from '@/services/api/generic.service';

export class JourneyPrescriptionService extends GenericService<Prescription> {

  constructor(journeyId: string) {
    super(`/menicon/v1/journeys/${journeyId}/prescriptions`);
  }
}
